export default __webpack_public_path__ + "static/media/logout_black.bf2234a1.svg";